import React from "react";
import PropTypes from "prop-types";
const COLUMN_TYPES = ["LABEL_COLUMN"];
const CELL_TYPES = ["LABEL_CELL", "TRASH_CAN"];
/**
 * UVTable:
 *  - Component strips gelTable prop of display in UVTransilluminator
 */
export function UVTable({ children }) {
  const stripGelTable = (gelTable) =>
    gelTable.reduce((gelTable, column) => {
      if (!COLUMN_TYPES.includes(column.colType)) {
        column = {
          ...column,
          colItems: column.colItems.filter(
            (cell) => !CELL_TYPES.includes(cell.cellType)
          ),
        };
        gelTable.push(column);
      }
      return gelTable;
    }, []);

  const [strippedTable] = React.useState(
    stripGelTable(children.props.gelTable)
  );

  return React.cloneElement(children, {
    title: "",
    gelTable: strippedTable,
    style: { width: "160px", padding: "2px" },
  });
}

UVTable.propTypes = {
  /**
   * The GelDraDrop component to use here. [ GelDragDrop , GelDragDropNew]
   */
  children: PropTypes.element,
};
